export enum InsightsChartType {
  LINE = 'line',
  BAR = 'bar',
}

export enum Pages {
  NOT_FOUND = 'notFound',
  PROJECT_LISTING = 'projects',
  SCHEDULING = 'routes',
  DRIVER_LISTING = 'drivers',
  SETTINGS = 'settings',
  ORDERS = 'orders',
  CUSTOMERS = 'customers',
  INSIGHTS = 'insights',
  INSIGHT_DETAILS = 'insights/details',
}

export enum QueryParamDataType {
  STRING = 'string',
  UUID = 'uuid',
  NUMBER = 'number',
  DATE = 'date',
  CUSTOM = 'custom',
  BOOLEAN = 'boolean',
}

export enum RequiredQueryParams {
  DATE = 'date',
  VIEW = 'view',
}

export enum DataQueryParams {
  ORDER = 'order',
  STOP = 'stop',
  ROUTE = 'route',
  DRIVER = 'driver',
  PAGE = 'page',
  VIEW = 'view',
}

export enum SettingsQueryParams {
  SETTINGS = 'settings',
  CALENDAR = 'calendar',
}

export enum BaseInsightsQueryParams {
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  CHART_TYPE = 'chart',
}

export enum InsightsDetailsQueryParams {
  METRIC = 'metric',
}

export enum WorkspaceSettingsViews {
  TEMPLATES = 'templates',
  PREFERENCES = 'preferences',
  TERRITORIES = 'territories',
}

export enum DriversPageViews {
  INVITE = 'invite',
}

export enum CompanySettingsViews {
  GENERAL = 'general',
  WORKSPACES = 'workspaces',
  CUSTOMER_NOTIFICATIONS = 'customer-notifications',
  DELIVERY_TRACKER = 'delivery-tracker',
  DRIVER_WORKFLOW = 'driver-workflow',
  BILLING = 'billing',
  INTEGRATIONS = 'integrations',
  TEAM = 'team',
  ROUTIFIC_API = 'routific-api',
  SHOPIFY = 'shopify',
  WEBHOOKS = 'webhooks',
}

export enum ApplicationType {
  'MOBILE' = 'MOBILE',
  'PLATFORM' = 'PLATFORM',
}

export const SchedulingQueryParams = {
  ...RequiredQueryParams, ...DataQueryParams, ...SettingsQueryParams,
};

export const OrderQueryParams = {
  ORDER: DataQueryParams.ORDER,
  PAGE: DataQueryParams.PAGE,
  SETTINGS: SettingsQueryParams.SETTINGS,
};

export const DriverQueryParams = {
  VIEW: DataQueryParams.VIEW,
  SETTINGS: SettingsQueryParams.SETTINGS,
  DRIVER: 'driver',
};

export const CustomerQueryParams = {
  CUSTOMER_PROFILE: 'customer',
  PAGE: DataQueryParams.PAGE,
};

export enum UserInviteStatus {
  'Pending' = 1,
  'Accepted' = 2,
  'Revoked' = 3,
  'Expired' = 4,
}
